import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/chevron-up.svg'
import _imports_1 from '@/app/ui/assets/svg/chevron-down.svg'
import _imports_2 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-a727bc3a")

_pushScopeId("data-v-a727bc3a")
const _hoisted_1 = {
  key: 0,
  class: "text-red-lp-100"
}
const _hoisted_2 = {
  key: 0,
  class: "pointer-events-none relative inset-y-0 right-0 flex items-center px-2"
}
const _hoisted_3 = { class: "text-red-lp-100 text-12px xxl:text-14px flex pl-1 gap-x-2" }
const _hoisted_4 = {
  src: _imports_2,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", {
    class: ["inline-block relative bottom-0 left-0 text-12px xxl:text-14px", `${_ctx.isCustomWidth ? '' : 'w-full'} ${_ctx.customClassHeight}`]
  }, [
    _createVNode("div", {
      class: 
        `bg-white ${
          _ctx.isExpand !== ''
            ? _ctx.isExpand && _ctx.openSelect && !_ctx.isDisabled
              ? _ctx.expandUpwards
                ? 'rounded-b'
                : 'rounded-t'
              : 'rounded'
            : _ctx.openSelect && !_ctx.isDisabled
            ? _ctx.expandUpwards
              ? 'rounded-b'
              : 'rounded-t'
            : 'rounded'
        } ${
          _ctx.isDisabled
            ? 'cursor-not-allowed text-gray-lp-600'
            : 'cursor-pointer text-black-lp-300'
        }
         ${
          _ctx.error
            ? 'border-red-lp-100'
            : 'border-gray-lp-400'
        } ${
          _ctx.disableBackground ? 'bg-gray-lp-1500' : ''
        } flex items-center border leading-tight px-3 py-2 xxl:py-2.5 font-normal truncate h-full`
      ,
      onClick: _cache[1] || (_cache[1] = () => (_ctx.openSelect ? _ctx.closeSelect() : _ctx.expandSelect()))
    }, [
      _createVNode("span", {
        class: 
          `align-middle truncate w-full ${_ctx.placeholderStyle} ${_ctx.customValueStyle}`
        
      }, [
        _createTextVNode(_toDisplayString(!_ctx.value.length
            ? _ctx.selectedItem?.name || _ctx.defaultValue || _ctx.placeholder
            : _ctx.value) + " ", 1),
        (_ctx.counter)
          ? (_openBlock(), _createBlock("span", _hoisted_1, "(" + _toDisplayString(_ctx.counter) + ")", 1))
          : _createCommentVNode("", true)
      ], 2),
      (!_ctx.isDisabled || _ctx.isCustomChevronDisable)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            (_ctx.isExpand !== '' ? _ctx.isExpand && _ctx.openSelect : _ctx.openSelect)
              ? (_openBlock(), _createBlock("img", {
                  key: 0,
                  src: _imports_0,
                  class: `w-4 ${_ctx.customChevronStyle}`,
                  alt: "chevron-up"
                }, null, 2))
              : (_openBlock(), _createBlock("img", {
                  key: 1,
                  src: _imports_1,
                  class: `w-4 ${_ctx.customChevronStyle}`,
                  alt: "chevron-down"
                }, null, 2))
          ]))
        : _createCommentVNode("", true)
    ], 2),
    (
        _ctx.isExpand !== ''
          ? _ctx.isExpand && _ctx.openSelect && !_ctx.isDisabled
          : _ctx.openSelect && !_ctx.isDisabled
      )
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: ["select w-full bg-white border border-gray-lp-400  pr-1 pl-4 py-1 z-50 flex-row", 
        `${_ctx.expandUpwards ? 'border-b-0 rounded-t' : 'border-t-0 rounded-b'} ${_ctx.customClassExpand}`
      ],
          style: `${_ctx.expandUpwards ? 'bottom: 40px' : ``}`
        }, [
          (_ctx.options.length > 0)
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: "options w-full flex flex-col gap-y-4 text-black-lp-300 overflow-auto pr-3 py-1.5 px-2",
                style: `${_ctx.isCustomMaxHeight ? '' : `max-height: 200px`}`
              }, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: `${index}`,
                    class: 
            `${
              _ctx.isActive(option) ? 'text-red-lp-100' : ''
            } ${_ctx.customOptionStyle} flex justify-between align-middle items-center ${
              option?.disabled
                ? 'cursor-not-allowed text-gray-lp-600'
                : 'cursor-pointer hover:text-red-lp-100'
            }`
          ,
                    onClick: () => _ctx.onSelect(option)
                  }, [
                    _createTextVNode(_toDisplayString(option.name) + " ", 1),
                    _withDirectives(_createVNode("img", {
                      src: require(`@/app/ui/assets/svg/check-red.svg`),
                      class: "w-6 max-w-none",
                      alt: "check-red"
                    }, null, 8, ["src"]), [
                      [_vShow, _ctx.isCheck && _ctx.isActive(option)]
                    ])
                  ], 10, ["onClick"]))
                }), 128))
              ], 4))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ], 6))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", _hoisted_3, [
      _withDirectives(_createVNode("img", _hoisted_4, null, 512), [
        [_vShow, _ctx.errorCaption]
      ]),
      _createTextVNode(" " + _toDisplayString(_ctx.errorCaption), 1)
    ], 512), [
      [_vShow, _ctx.error]
    ])
  ], 2)), [
    [_directive_click_outside, () => _ctx.closeSelect()]
  ])
})